/* ⚛ REACT */
import { useState, useEffect } from "react";

/* 🧩 COMPONENTS */
import { Tooltip } from "../../Components";

/* 📁 ASSETS*/
import { Ajuda } from "../../Assets/icons";

/* 🎨 STYLES */
import { RadioContainer, Help } from "./styles";

const InputRadio = ({ name, options, value, onChange, disabled = []}) => {

    const [selectedValue, setSelectedValue] = useState(value);
    
    const handleRadioChange = async (value) => {
        const success = await onChange(value);

        if (success) {
            setSelectedValue(value);
        }
    };

    useEffect(() => {
        setSelectedValue(value); 
    }, [value]);


    useEffect(() => {
        if (disabled.length > 0) {
            setSelectedValue(value);
        }
    }, [disabled, value]);

    return(
        <>
            {options.map((option, index) => {
            
                const isOptionDisabled = Array.isArray(disabled) && disabled.includes(index);

                return (
                    <RadioContainer key={option.id} $disabled={isOptionDisabled}>
                        <input
                            id={option.id}
                            type="radio"
                            name={name}
                            value={option.id}
                            checked={!isOptionDisabled && selectedValue === option.id}
                            readOnly
                        />
                        <span className="radio-circle" onClick={() => !isOptionDisabled && handleRadioChange(option.id) }></span>
                        <label>{option.label}</label>
                        {option.help && <Tooltip key={option.id} text={option.help}><Help src={Ajuda} /></Tooltip>}
                    </RadioContainer>
                )
            })}
        </>
    )
}

export default InputRadio;